export const USER_GROUP_VALUES = {
  UNKNOWN: 'UNKNOWN',
  CUSTOMER: 'CUSTOMER',
  MERCHANT: 'MERCHANT',
  STAFF: 'STAFF',
}

export const USER_GROUP_NAME = 'user_type'

export const SERVER_ZONE = 'EU'
export const MARKETING_QUERY_PARAMETERS = [
  'utm_source',
  'utm_campaign',
  'utm_id',
  'utm_content',
  'utm_medium',
  'utm_term',
  'fbclid',
  'gclid',
  'gbraid',
]
